import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

const DAILY_NOTES_URL = `${TENANT_API_URL}/daily-notes`;

export const getTodayIncidents = async () => {
  try {
    const response = await axiosInstance.get(
      `${DAILY_NOTES_URL}/today-incidents`
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getLatestDailyNotes = async () => {
  try {
    const response = await axiosInstance.get(
      `${DAILY_NOTES_URL}/latest?page=1&limit=3`
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getAllDailyNotes = async (urlWithFilters: any): Promise<any> => {
  try {
    // Include pagination parameters in the URL if needed
    const response = await axiosInstance.get(urlWithFilters);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getDailyNotes = async (data: Record<string, unknown>) => {
  try {
    const response = await axiosInstance.get(DAILY_NOTES_URL, {
      params: data,
    });
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getDailyNoteById = async (id: string) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.get(`${DAILY_NOTES_URL}/${id}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const createDailyNoteTask = async (data: FormData) => {
  try {
    const response = await axiosInstance.post(`${DAILY_NOTES_URL}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateDailyNoteTask = async (id: string, data: FormData) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.put(`${DAILY_NOTES_URL}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const deleteDailyNote = async (id: string, data: any) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.post(`${DAILY_NOTES_URL}/${id}`, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
